var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.61895 6.25517L0.581053 1.96886C1.24632 0.899383 2.44211 0.183594 3.78947 0.183594H12.2105C13.5579 0.183594 14.7453 0.890962 15.4189 1.96044L9.39789 6.23833C8.54737 6.80254 7.45263 6.80254 6.61895 6.25517ZM15.9832 3.63623L10.3579 7.6278C9.63368 8.1078 8.80842 8.34359 7.99158 8.34359C7.17474 8.34359 6.37474 8.1078 5.66737 7.63623L0.0168421 3.63623C0.00842105 3.7457 0 3.86359 0 3.97307V9.0257C0 11.1141 1.70105 12.8152 3.78947 12.8152H12.2105C14.2989 12.8152 16 11.1141 16 9.0257V3.97307C16 3.86359 15.9916 3.7457 15.9832 3.63623Z",
    fill: "#474554"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.7119e852e3cecba09d974e7a7063fb41.svg";
export { ForwardRef as ReactComponent };